// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3O5lY","alert":"SettungsInbox_alert__3C_2T"};